import { Form, } from 'antd'
import React, { Component } from 'react'
import './graphStatistics.scss'
import downloadPDF from './downloadPDF'
import moment from 'moment';
const echarts = require('echarts');
let myChart;
export class PaintGraphStatistics extends Component {
  state = {
    showKey: '1',
    startValue: moment(),
    endValue: moment(),
    endOpen: false,
    startOpen: false,
    handlStartValue: moment(),
    handlStartOpen: false,
    handlEndValue: moment(),
    handlEndOpen: false,
    localStartValue: moment(),
    localEndValue: moment(),
    localEndOpen: false,
    localStartOpen: false,
    dataList: [],
    showType: 'histogram',
    consultHospitalCode: '',
    consultHospitalName: '',
    applyHospitalCode: '',
    applyHospitalName: '',
    consultHospitalList: [],
    applyHospitalList: [],
    consultSum: {
      ECG_Consulation_Sum: 0,
      HOLTER_Consulation_Sum: 0,
      BP_Consulation_Sum: 0
    },
    statisticalType: '',
    paintShow: false,
  }
  moreThanTwentyPagesRef = []
  async componentDidMount() {
    var dom = document.getElementById("paintEcharts");
    myChart = echarts.init(dom);
    let option = this.props.paintOption
    if (option && option.dataZoom) {
      option.dataZoom[0].show = false
      option.dataZoom[0].start = this.props.dataZoomStart
      option.dataZoom[0].end = this.props.dataZoomEnd
    }
    option.animation = false
    myChart.setOption(option)
    await downloadPDF(this.moreThanTwentyPagesRef, 0);//因为超过17个字需要换行，分页会出现切割情况，暂用循环打印
    this.props.closeModal()
  }
  render() {
    const { consultSum } = this.props
    return (
      <div className="truePaintPage">
        <div className='detaileView'
          ref={el => (this.lessThanTwentyPagesRef = el)}//小于20页用切割
          style={{
            width: 297 + 'mm',
            height: 210 + 'mm',
            color: '#000',
            zoom: 1,
            overflow: 'hidden',
          }}>
          <div style={{
            padding: '5mm 10mm',
          }}
            ref={el => { this.moreThanTwentyPagesRef[0] = el }}
          >
            {this.props.showType === 'tendency' && this.props.consultHospitalName && !this.props.applyHospitalName ?
              <div className="consultHospitalTitle">会诊机构：{this.props.consultHospitalName}</div> : null
            }
            {this.props.showType === 'tendency' && this.props.applyHospitalName ?
              <div className="consultHospitalTitle">申请机构：{this.props.applyHospitalName}</div> : null
            }
            <div className='title'>
              {
                this.props.showKey === '1' ? '会诊总量——' : this.props.showKey === '2' ? '机构总诊量——' : '本地检查量——'
              }
              {
                this.props.showType === 'tendency' ? '趋势图' : '柱状图'
              }
            </div>
            <div id="paintEcharts" style={{ height: '175mm' }}></div>
            <div className="graphTotalBox">
              会诊总量：
              <span></span>静息心电 - {consultSum.ECG_Consulation_Sum}例
              <span></span>动态心电 - {consultSum.HOLTER_Consulation_Sum}例
              <span></span>动态血压 - {consultSum.BP_Consulation_Sum}例
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Form.create()(PaintGraphStatistics)
